"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_designer_constants_1 = require("./form-designer.constants");
var FormDragulaOptions = /** @class */ (function () {
    function FormDragulaOptions() {
        this.FIELDS_BAG_OPTIONS = {
            accepts: function (el, target) {
                if (el.getAttribute('is_nested_card') === '1') {
                    return (target.id !==
                        form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER &&
                        target.id !==
                            form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER &&
                        target.id !==
                            form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER);
                }
                else {
                    return (target.id ===
                        form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER ||
                        target.id === form_designer_constants_1.FormDesignerConstants.UPPER_ROW_CONTAINER ||
                        target.id === form_designer_constants_1.FormDesignerConstants.LOWER_ROW_CONTAINER ||
                        target.id ===
                            form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER ||
                        target.id ===
                            form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER ||
                        target.id ===
                            form_designer_constants_1.FormDesignerConstants.CONTROLLER_SCROLLER_TOP_ELEMENT ||
                        target.id ===
                            form_designer_constants_1.FormDesignerConstants.CONTROLLER_SCROLLER_BOTTOM_ELEMENT ||
                        target.id ===
                            form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER ||
                        target.id === form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN);
                }
            },
            copy: function (el, source) {
                return (source.id !== form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER &&
                    source.id !== form_designer_constants_1.FormDesignerConstants.UPPER_ROW_CONTAINER &&
                    source.id !== form_designer_constants_1.FormDesignerConstants.LOWER_ROW_CONTAINER &&
                    source.id !==
                        form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER &&
                    source.id !==
                        form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER);
            },
            moves: function (el, source, handle) {
                if (el.getAttribute('is_nested_card') === '1') {
                    return true;
                }
                else {
                    return ((el.id === form_designer_constants_1.FormDesignerConstants.NEW_FIELD_CONTROLLER ||
                        el.id === form_designer_constants_1.FormDesignerConstants.NEW_NESTED_CARD_ID ||
                        (el.id &&
                            el.id.startsWith(form_designer_constants_1.FormDesignerConstants.CONTROLLER_CONTENT) &&
                            el.getAttribute('is_central_settings_openned') !==
                                '1') ||
                        el.id === form_designer_constants_1.FormDesignerConstants.DROPPED_NESTED_CARD ||
                        el.id === 'control_node') &&
                        handle.id !== 'resize_handler' &&
                        handle.id !== 'nested_resize_handler');
                }
            },
            direction: 'horizontal',
        };
        this.CARD_OPTIONS = {
            moves: function (el, source, handle) {
                if (handle.id === 'card_handler') {
                    return true;
                }
                return el.id === form_designer_constants_1.FormDesignerConstants.NEW_CARD_ID;
            },
            accepts: function (el, target, source, sibling) {
                return (target.id === form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER ||
                    target.id === form_designer_constants_1.FormDesignerConstants.CARD_TRASH_BIN ||
                    target.id === form_designer_constants_1.FormDesignerConstants.CARD_SCROLLER_TOP_ELEMENT ||
                    target.id === form_designer_constants_1.FormDesignerConstants.CARD_SCROLLER_BOTTOM_ELEMENT);
            },
            copy: function (el, source) {
                return source.id !== form_designer_constants_1.FormDesignerConstants.CARDS_CONTAINER;
            },
        };
    }
    return FormDragulaOptions;
}());
exports.FormDragulaOptions = FormDragulaOptions;
//# sourceMappingURL=form-dragula-options.js.map